import React, { Component } from "react";
import "./Footer.scss";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowUp } from "@fortawesome/free-solid-svg-icons";

class Footer extends Component {
	constructor() {
		super();
		this.state = {
			onTop: "onTop-hidden",
		};
		this.year = new Date().getFullYear();
	}
	componentDidMount() {
		this.onScroll();
	}

	componentWillUnmount() {}

	onScroll() {
		window.addEventListener("scroll", (e) => {
			let scrollPosition = window.scrollY;
			if (scrollPosition > 10) {
				this.setState({ onTop: "onTop-no-hidden" });
			} else if (scrollPosition <= 10) {
				this.setState({ onTop: "onTop-hidden" });
			}
		});
	}
	onTopMove() {
		window.scroll({
			top: 0,
			behavior: "smooth",
		});
	}

	render() {
		return (
			<React.Fragment>
				<div className="curved-education">
					<svg viewBox="0 0 1440 319">
						<path
							fill="#14213D"
							d="M0,192L60,208C120,224,240,256,360,245.3C480,235,600,181,720,186.7C840,192,960,256,1080,277.3C1200,299,1320,277,1380,266.7L1440,256L1440,320L1380,320C1320,320,1200,320,1080,320C960,320,840,320,720,320C600,320,480,320,360,320C240,320,120,320,60,320L0,320Z"
						></path>
					</svg>
				</div>
				<div className="copyright_part">
					<div className="container">
						<div className="row">
							<div className="col-lg-12">
								<div className="copyright_text">
									<p>
										Designed and Developed by Lopez Damian | Copyright &copy;
										{this.year}
									</p>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div onClick={this.onTopMove} className={"onTop " + this.state.onTop}>
					<FontAwesomeIcon className="icon" icon={faArrowUp} />
				</div>
			</React.Fragment>
		);
	}
}

export default Footer;
